// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Om28","productName":"Table_productName__10OeO"};